const stripHtml = (html: string): string =>
  html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();

export const filterNotesBySearchTerm = (
  notes: any[],
  searchTerm: string
): any[] => {
  if (!searchTerm.trim()) {
    return notes;
  }

  const searchLower: string = searchTerm.toLowerCase();

  return notes.filter((note: any) => {
    // Search in title
    if (note.title && note.title.toLowerCase().includes(searchLower)) {
      return true;
    }

    // Search in body (strip HTML — editor stores rich text as markup)
    if (note.body && stripHtml(note.body).toLowerCase().includes(searchLower)) {
      return true;
    }

    // Search in content/description
    if (note.content && stripHtml(note.content).toLowerCase().includes(searchLower)) {
      return true;
    }

    // Search in description field
    if (
      note.description &&
      note.description.toLowerCase().includes(searchLower)
    ) {
      return true;
    }

    // Search in author name
    if (
      note.author &&
      note.author.firstName &&
      note.author.firstName.toLowerCase().includes(searchLower)
    ) {
      return true;
    }

    if (
      note.author &&
      note.author.lastName &&
      note.author.lastName.toLowerCase().includes(searchLower)
    ) {
      return true;
    }

    // If note has parsed data, search in that too
    if (note.data) {
      try {
        const parsedData = JSON.parse(note.data);

        if (
          parsedData.body &&
          stripHtml(parsedData.body).toLowerCase().includes(searchLower)
        ) {
          return true;
        }

        if (
          parsedData.title &&
          parsedData.title.toLowerCase().includes(searchLower)
        ) {
          return true;
        }

        if (
          parsedData.content &&
          parsedData.content.toLowerCase().includes(searchLower)
        ) {
          return true;
        }

        if (
          parsedData.description &&
          parsedData.description.toLowerCase().includes(searchLower)
        ) {
          return true;
        }
      } catch (error) {
        // If JSON parsing fails, continue with other searches
      }
    }

    return false;
  });
};
